"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intlReducer = intlReducer;
Object.defineProperty(exports, "IntlProvider", {
  enumerable: true,
  get: function get() {
    return _IntlProvider2.default;
  }
});
Object.defineProperty(exports, "Provider", {
  enumerable: true,
  get: function get() {
    return _Provider2.default;
  }
});
exports.initialState = exports.updateIntl = exports.UPDATE = void 0;

var _IntlProvider2 = _interopRequireDefault(require("./components/IntlProvider"));

var _Provider2 = _interopRequireDefault(require("./components/Provider"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var UPDATE = '@@intl/UPDATE';
exports.UPDATE = UPDATE;

var updateIntl = function updateIntl(_ref) {
  var locale = _ref.locale,
      formats = _ref.formats,
      messages = _ref.messages;
  return {
    type: UPDATE,
    payload: {
      locale: locale,
      formats: formats,
      messages: messages
    }
  };
};

exports.updateIntl = updateIntl;
var initialState = {
  locale: 'en',
  messages: {}
};
exports.initialState = initialState;

function intlReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.type !== UPDATE) {
    return state;
  }

  return _objectSpread({}, state, action.payload);
}